<script setup lang="ts">
  import { computed } from 'vue'
  import { useModalStore } from '@/stores/modal'
  import { useHomeChatStore } from '@/stores/home-chat'
  import { track } from '@/helpers/mixpanelDes'
  import DesTile from '@/components/home/DesTile.vue'
  import DesButtonLink from '@/components/button/DesButtonLink.vue'
  import DesContentNarrow from '@/components/DesContentNarrow.vue'

  const modal = useModalStore()
  const homeChat = useHomeChatStore()

  const creatorType = computed(() => (homeChat.forcedType === 'presentation' ? 'presentation' : 'ebook'))
  const tileVariant = computed(() => (creatorType.value === 'presentation' ? 'slide' : 'document'))

  function openMore() {
    track('dashboard-link-clicked', { target: 'more-creation-options' })
    modal.open(() => import('@/components/modal/DesModalMoreCreation.vue'), {
      exclude: creatorType.value === 'presentation' ? ['from-pptx', 'from-gslides'] : ['from-docx', 'from-gdoc'],
    })
  }
</script>

<template>
  <DesContentNarrow>
    <div class="flex flex-col gap-8">
      <div class="text-black-40 text-center text-sm">
        Or
        <DesButtonLink @click="openMore">choose another way</DesButtonLink>
        to begin
      </div>

      <div class="grid gap-6 sm:grid-cols-3">
        <DesTile
          v-if="creatorType === 'presentation'"
          image="/dashboard/new-project/ico-from-pptx.png"
          title="Import PPTX"
          desc="Upload PowerPoint"
          :variant="tileVariant"
          :to="`/creator/${creatorType}/from-pptx`"
        />
        <DesTile
          v-else
          image="/dashboard/new-project/ico-from-docx.png"
          title="Import DOCX"
          desc="Upload Word doc"
          :variant="tileVariant"
          :to="`/creator/${creatorType}/from-docx`"
        />
        <DesTile
          v-if="creatorType === 'presentation'"
          image="/dashboard/new-project/ico-from-gslides.png"
          title="Import Google Slides"
          desc="Paste a share link"
          :variant="tileVariant"
          :to="`/creator/${creatorType}/from-gslides`"
        />
        <DesTile
          v-else
          image="/dashboard/new-project/ico-from-gdoc.png"
          title="Import Google Doc"
          desc="Connect from drive"
          :variant="tileVariant"
          :to="`/creator/${creatorType}/from-gdoc`"
        />
        <DesTile
          image="/dashboard/new-project/ico-from-scratch.png"
          title="Start from scratch"
          desc="Begin with a blank"
          :variant="tileVariant"
          :to="`/creator/${creatorType}/from-scratch`"
        />
      </div>

      <div class="text-black-40 text-center text-sm">
        More ways to create —
        <DesButtonLink @click="openMore">
          {{ creatorType === 'presentation' ? 'PDF, blog post, Wordgenie' : 'video import, podcast, PDF flipbook' }}
        </DesButtonLink>
      </div>
    </div>
  </DesContentNarrow>
</template>
